import { render, staticRenderFns } from "./RELMotoristaVeiculo.vue?vue&type=template&id=7e291ee2&"
import script from "./RELMotoristaVeiculo.vue?vue&type=script&lang=js&"
export * from "./RELMotoristaVeiculo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports